export default __webpack_public_path__ + "static/25-year-stamp-5512a2a0b4a8c52754446772e4454c7f.svg";